import { useIdentityStore } from '@/stores/identity/auth'
import type { UserRole } from '@bayerntek/identity-lib'

export const RoleGuard = (allowed_roles: UserRole[]) => () => {
  const identityStore = useIdentityStore()
  return identityStore.is_only_for(allowed_roles)
}
